import React, { FC, PropsWithChildren } from 'react';

import cx from './SecondaryLevelPageWrapper.module.css';

type Props = {};

export const SecondaryLevelPageWrapper: FC<PropsWithChildren<Props>> = ({ children }) => {
  return (
    <div className={cx('secondary-level-page-wrapper')}>
      <div className={cx('secondary-level-page')}>{children}</div>
    </div>
  );
};
